import { Component, Input, OnInit } from '@angular/core';
import { AUTH_REASON } from 'src/app/angular-wallet-base/constants';
import { AppModeService, } from 'src/app/angular-wallet-base/services/app-mode.service';
import { presentToast } from 'src/app/angular-wallet-base/utils';
import { PinModalComponent, } from 'src/app/components/pin-modal/pin-modal.component';
import { ModalController, Platform, ToastController, } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { OneInchService } from 'src/app/angular-wallet-base/services/one-inch.service';
import { GetTradeOrdersAction, GetTradeOrdersHistoryAction, RemoveTradeOrdersAction } from 'src/app/angular-wallet-base/actions/wallet.actions';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';

@Component({
  selector: 'app-cancel-order',
  templateUrl: './cancel-order.component.html',
  styleUrls: ['./cancel-order.component.scss'],
})
export class CancelOrderComponent implements OnInit {

  @Input() order: any;
  public isDesktopMode;
  public loader: boolean = false;

  constructor(
    protected store: Store<AppState>,
    private modal: ModalController,
    public appMode: AppModeService,
    private modalCtrl: ModalController,
    private oneInchService: OneInchService,
    private translate: TranslateService,
    private toastController: ToastController,
    private platform: Platform,
  ) {
    this.appMode.isDesktopMode.subscribe((mode) => (this.isDesktopMode = mode));
  }

  ngOnInit() {
    Logger.info(this.order)
  }

  async cancelOrder() {
    const modal = await this.modalCtrl.create({
      component: PinModalComponent,
      backdropDismiss: false,
      cssClass: 'fullscreen-modal',
      componentProps: {
        reason: AUTH_REASON.CANCEL_TRADE_ORDER
      },
      id: 'pinModal'
    });
    await modal.present();
    await modal.onDidDismiss().then(response => {
      if (response.data && response.data.pin) {
        this.confirmCancelOrder(response.data.pin, this.order);
      }
    });
  }

  // cancel-trade-order
  async confirmCancelOrder(pin: string, orderDetails: any) {
    this.loader = true;
    try {
      const order = orderDetails;
      const cancelOrder = await this.oneInchService.cancelOrder(pin, order.data);
      this.loader = false;
      if (cancelOrder) {
        await presentToast('trade_cancel_model.success', 'trade_cancel_model.success_message', this.translate, this.toastController, this.platform);
      } else {
        await presentToast('trade_cancel_model.failed', 'trade_cancel_model.failed_message', this.translate, this.toastController, this.platform);
      }

      setTimeout(() => {
        this.loader = false;
        // get open orders and history
        this.store.dispatch(new RemoveTradeOrdersAction(order));
        this.store.dispatch(new GetTradeOrdersHistoryAction(true));
        this.closeModal();
      }, 1200)
    } catch (error) {
      Logger.info('cancel order', error);

      this.loader = false;
      await presentToast('trade_cancel_model.failed', 'trade_cancel_model.failed_message', this.translate, this.toastController, this.platform);
      this.closeModal();
    }
  }

  closeModal() {
    this.modal.dismiss();
  }
}
